import { render, staticRenderFns } from "./StatDetailTable.vue?vue&type=template&id=a234bfcc&scoped=true&"
import script from "./StatDetailTable.vue?vue&type=script&lang=js&"
export * from "./StatDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./StatDetailTable.vue?vue&type=style&index=0&id=a234bfcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a234bfcc",
  null
  
)

export default component.exports